import { ItemData } from 'core/models/Template'

export const PRODUCT_MENU_CATALOG_TYPE = 'productMenu' as const

export const PRODUCT_MENU_CATALOG_CONFIG = {
    type: PRODUCT_MENU_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
    treeView: false,
} as const

export type ProductMenuSelectedItems = ItemData[]
